import { render, staticRenderFns } from "./JoszakiDropdownButton.vue?vue&type=template&id=cc4f485a"
import script from "./JoszakiDropdownButton.vue?vue&type=script&lang=js"
export * from "./JoszakiDropdownButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports